import { createTheme } from "@material-ui/core/styles";

export default createTheme({
  palette: {
    primary: { main: "#13497a" },
    secondary: { main: "#299d32", contrastText: "#fff" },
    background: { default: "#f7f9fc", paper: "#fff" }
  },
  typography: { fontFamily: "'Open Sans', Arial, sans-serif", fontSize: 14 },
  shape: { borderRadius: 6 },
  overrides: {
    MuiButton: { root: { fontWeight: 700, textTransform: "none" } },
    MuiFormHelperText: { root: { marginLeft: 0 } }
  }
});
